// import React, { createContext, useContext, useState } from 'react';

// const PatientContext = createContext();

// export const PatientProvider = ({ children }) => {
//   const [patientData, setPatientData] = useState({});

//   const updatePatientData = (updates) => {
//     setPatientData(prev => ({ ...prev, ...updates }));
//   };

//   const clearPatientData = () => {
//     setPatientData({});
//   };

//   return (
//     <PatientContext.Provider value={{ 
//       patientData, 
//       setPatientData, 
//       updatePatientData, 
//       clearPatientData 
//     }}>
//       {children}
//     </PatientContext.Provider>
//   );
// };

// export const usePatient = () => {
//   const context = useContext(PatientContext);
//   if (!context) {
//     throw new Error('usePatient must be used within a PatientProvider');
//   }
//   return context;
// };


// //Layout for the PatientProvider component
// const PatientCheckInLayout = ({ children }) => {
//   return (
//     <PatientProvider>
//         {children}
//     </PatientProvider>
//   );
// };

// export default PatientCheckInLayout;

import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const PatientContext = createContext();

const STORAGE_KEY = 'patientCheckInData';

export const PatientProvider = ({ children }) => {
  const [patientData, setPatientDataState] = useState(() => {
    // Initialize from sessionStorage if available
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        console.log('PatientProvider - Restored from sessionStorage:', parsed);
        return parsed;
      }
    } catch (e) {
      console.error('PatientProvider - Error reading sessionStorage:', e);
    }
    return {};
  });

  // Persist to sessionStorage whenever patientData changes
  useEffect(() => {
    try {
      if (patientData && Object.keys(patientData).length > 0) {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(patientData));
      }
    } catch (e) {
      console.error('PatientProvider - Error writing sessionStorage:', e);
    }
  }, [patientData]);

  const setPatientData = useCallback((valueOrUpdater) => {
    if (typeof valueOrUpdater === 'function') {
      setPatientDataState((prev) => {
        const next = valueOrUpdater(prev);
        return next;
      });
    } else {
      setPatientDataState(valueOrUpdater);
    }
  }, []);

  const updatePatientData = useCallback((updates) => {
    setPatientDataState(prev => ({ ...prev, ...updates }));
  }, []);

  const clearPatientData = useCallback(() => {
    setPatientDataState({});
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      console.error('PatientProvider - Error clearing sessionStorage:', e);
    }
  }, []);

  return (
    <PatientContext.Provider value={{ 
      patientData, 
      setPatientData, 
      updatePatientData, 
      clearPatientData 
    }}>
      {children}
    </PatientContext.Provider>
  );
};

export const usePatient = () => {
  const context = useContext(PatientContext);
  if (!context) {
    throw new Error('usePatient must be used within a PatientProvider');
  }
  return context;
};


//Layout for the PatientProvider component
const PatientCheckInLayout = ({ children }) => {
  return (
    <PatientProvider>
        {children}
    </PatientProvider>
  );
};

export default PatientCheckInLayout;